import { render, staticRenderFns } from "./PreviewTable.vue?vue&type=template&id=bd99f488&"
import script from "./PreviewTable.vue?vue&type=script&lang=js&"
export * from "./PreviewTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports